module.exports = __webpack_public_path__ + "766abfed2211b0baf57419c4aa5ed000.pdf";